import React from "react";

import { Chip, Grid, makeStyles, Typography } from "@material-ui/core";

import { carrierYardAccessRows } from "../../../utils/carrierUserUtils";

const useStyles = makeStyles((theme) => ({
  chip: {
    minWidth: "7em",
  },
  blocked: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },
  yard: {
    lineHeight: "32px",
  },
}));

// What each state is called on the profile, and how loudly. A block and a
// removal are both the transload's decision, so both name it — the difference is
// that a blocked user still holds the membership, and a removed one does not.
const STATE_LABELS = {
  active: "Active",
  blocked: "Blocked",
  none: "No access",
};

/**
 * Where a colleague stands at each of the company's transloads.
 *
 * Read-only, and not for want of a control: which transloads a carrier user
 * works is no longer a per-user question here — joining the company grants all
 * of them (ValidateCreateButton) — so the only thing a profile has to say about
 * access is where a transload has taken it away. That is a manager's decision at
 * their own transload, and a dispatcher's part in it is knowing why a colleague
 * cannot sign in there.
 *
 * Nothing at all is said when the company works one transload: "Active" against
 * the only transload there is answers a question nobody asked, and the states
 * worth reporting are announced instead.
 */
export const CarrierUserYardAccess = ({ record, appUser, isSelf }) => {
  const classes = useStyles();

  const rows = carrierYardAccessRows(
    record?.reloadYardCarriers?.items,
    appUser?.reloadYardCarriers?.items,
    appUser?.appType,
    appUser?.carrierId,
  );
  const exceptions = rows.filter((row) => row.state !== "active");
  if (rows.length < 2 && !exceptions.length) return null;

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="overline" color="textSecondary">
          Transload Access
        </Typography>
      </Grid>
      {rows.map((row) => (
        <Grid container item xs={12} spacing={1} key={row.reloadYardId}>
          <Grid item xs={7} sm={5}>
            <Typography variant="body2" className={classes.yard}>
              {row.name}
            </Typography>
          </Grid>
          <Grid item xs={5} sm={7}>
            <Chip
              size="small"
              label={STATE_LABELS[row.state]}
              variant={row.state === "active" ? "outlined" : "default"}
              className={
                row.state === "blocked"
                  ? `${classes.chip} ${classes.blocked}`
                  : classes.chip
              }
            />
          </Grid>
        </Grid>
      ))}
      {Boolean(exceptions.length) && (
        <Grid item xs={12}>
          <Typography variant="caption" color="textSecondary">
            {isSelf
              ? "A transload can withdraw your access to it. Ask that transload to restore it."
              : "Blocked is a transload's own decision, and only that transload can lift it. Someone with no access can be invited again from New User — but a block stays in place."}
          </Typography>
        </Grid>
      )}
    </>
  );
};
